import Amplify from "aws-amplify";
import "bootstrap/js/dist/dropdown";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import config from "./config";
import { AuthProvider } from "./contexts/AuthContext";
import { PlanProvider } from "./contexts/PlanContext";
import "./index.scss";
import { setGlobalHeader } from "./libs/apiReqOptions";

const configObj = config.getConfigObject();

// AUTH_PROVIDER can be used to hit the API locally in serverless offline mode--set it as a global header if provided
// Amplify.configure is supposed to be able to support setting a global header, but evidently it doesn't work quite right:
// https://github.com/aws-amplify/amplify-js/issues/515
if (configObj.cognito.AUTH_PROVIDER) {
  setGlobalHeader({
    "cognito-authentication-provider": configObj.cognito.AUTH_PROVIDER,
  });
}

Amplify.configure({
  Auth: {
    // mandatorySignIn: true,
    region: configObj.cognito.REGION,
    userPoolId: configObj.cognito.USER_POOL_ID,
    identityPoolId: configObj.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: configObj.cognito.APP_CLIENT_ID,
  },
  //  Storage: {
  //    region: config.s3.REGION,
  //    bucket: config.s3.BUCKET,
  //    identityPoolId: config.cognito.IDENTITY_POOL_ID
  //  },
  API: {
    endpoints: [
      {
        name: "app-api",
        endpoint: configObj.apiGateway.URL,
        region: configObj.apiGateway.REGION,
      },
      {
        name: "events-api",
        endpoint: configObj.eventsApiGateway.URL,
        region: configObj.eventsApiGateway.REGION,
      },
    ],
  },
});

ReactDOM.render(
  <Router>
    <AuthProvider>
      <PlanProvider>
        <App />
      </PlanProvider>
    </AuthProvider>
  </Router>,
  document.getElementById("root")
);

//user pool
//Pool Id us-west-2_UWABPIr8P
//Pool ARN arn:aws:cognito-idp:us-west-2:240689848125:userpool/us-west-2_UWABPIr8P

//app client id for user pool: 3debq47t5k7bn6bv7g458lf6a0

//cognito domain https://taabl.auth.us-west-2.amazoncognito.com
